<template>
  <label class="f-file-input-wrapper">
    <div class="f-file-input-button">
      <f-icon
        v-if="icon"
        :name="icon" />
      <span>{{ label }}</span>
    </div>
    <input
      ref="input"
      type="file"
      @change="index !== false ? onChange($event, index) : onChange($event)"
      class="f-file-input"
      :id="id"
      :accept="accept"
      :aria-describedby="id"
      :multiple="multiple"/>
  </label>
</template>

<script>
export default {
  name: 'f-file-input',
  props: {
    id: {
      type: String,
      default: '',
      required: true
    },
    index: {
      type: [Boolean, Number],
      default: false,
      required: false
    },
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Wybierz plik'
    },
    onChange: {
      type: Function,
      default: () => false,
      required: false
    },
    multiple: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: Array,
      default: () => []
    },
    accept: {
      type: String,
      default: ''
    }
  }
}
</script>
